import { createContext } from "react"
import { ModalsKeys } from "./Modals/ModalTypes"
import type { ModalContextProps } from "./Modals/ModalTypes"

interface ModalContextState {
    modal: ModalsKeys
    setModal: (modal: ModalsKeys) => void
    props: ModalContextProps
    setProps: (props: ModalContextProps) => void
}

const contextDefaultValues: ModalContextState = {
    modal: ModalsKeys.None,
    setModal: () => {},
    setProps: () => {},
    props: {},
}

export const ModalContext = createContext<ModalContextState>(contextDefaultValues)
